function yhI18n(k, fb) {
  var el = document.getElementById('yomi-search-results');
  return (el && el.dataset && el.dataset[k]) || fb;
}
// === MOBILE HEADER TOGGLE ===
document.addEventListener('DOMContentLoaded', function() {
  function isMobile() { return window.innerWidth <= 989; }

  var mobileHeader = document.querySelector('.yomi-mobile-header');
  var mobileDrawer = document.getElementById('yomi-mobile-drawer');
  var menuBtn = document.getElementById('yomi-mobile-menu-btn');
  var closeBtn = document.getElementById('yomi-mobile-close');
  var cartBtn = document.getElementById('yomi-mobile-cart-btn');

  function toggleMobileHeader() {
    if (isMobile()) {
      if(mobileHeader) mobileHeader.style.display = 'flex';
    } else {
      if(mobileHeader) mobileHeader.style.display = 'none';
      if (typeof closeMobileMenu === 'function') closeMobileMenu();
    }
  }

  // Variabile per salvare la posizione dello scroll
  let scrollY = 0;

  // Funzione per aprire il menu mobile
  function openMobileMenu() {
    if (!mobileDrawer) return;

    // Salva la posizione corrente dello scroll
    scrollY = window.scrollY;

    // Aggiungi classe al body per bloccare lo scroll
    document.body.classList.add('yomi-menu-open');
    document.body.style.top = `-${scrollY}px`;

    // Mostra il drawer con la classe active
    mobileDrawer.classList.add('active');

    // Resetta lo scroll del contenuto del menu
    var menuContent = document.getElementById('yomi-mobile-menu-content');
    if (menuContent) {
      menuContent.scrollTop = 0;
    }

    // Aggiungi listener per bloccare touchmove sul body
    document.addEventListener('touchmove', handleTouchMove, { passive: false });
  }

  // Funzione per chiudere il menu mobile
  function closeMobileMenu() {
    if (!mobileDrawer) return;

    // Aggiungi classe per animazione di chiusura
    mobileDrawer.classList.add('closing');
    mobileDrawer.classList.remove('active');

    // Dopo l'animazione, esegui il cleanup
    setTimeout(function() {
      mobileDrawer.classList.remove('closing');

      // Rimuovi la classe dal body
      document.body.classList.remove('yomi-menu-open');
      document.body.style.top = '';

      // Ripristina la posizione dello scroll
      window.scrollTo(0, scrollY);

      // Resetta tutti i sottomenu allo stato iniziale
      document.querySelectorAll('.yomi-mobile-menu-sub').forEach(function(sub) {
        sub.classList.remove('sub-visible', 'sub-closing');
      });
      var mainMenu = document.getElementById('yomi-mobile-menu-main');
      if (mainMenu) mainMenu.classList.remove('main-hidden');
    }, 350);

    // Rimuovi il listener touchmove
    document.removeEventListener('touchmove', handleTouchMove, { passive: false });
  }

  // Funzione globale per chiudere il drawer (usata da onclick nel footer)
  window.closeMobileDrawer = closeMobileMenu;

  // Gestisce il touchmove per permettere scroll solo nel menu
  function handleTouchMove(e) {
    var menuContent = document.getElementById('yomi-mobile-menu-content');
    var target = e.target;

    // Controlla se il touch è dentro il contenuto del menu
    var isInsideMenuContent = menuContent && menuContent.contains(target);

    // Controlla se il touch è dentro un submenu scrollabile
    var submenu = target.closest('.yomi-mobile-menu-sub');
    var isInsideSubmenu = submenu && submenu.classList.contains('sub-visible');

    // Permetti scroll solo se siamo dentro il contenuto del menu o un submenu visibile
    if (!isInsideMenuContent && !isInsideSubmenu) {
      e.preventDefault();
      return;
    }

    // Gestisci il bounce effect su iOS
    var scrollableElement = isInsideSubmenu ? submenu : menuContent;
    if (scrollableElement) {
      var scrollTop = scrollableElement.scrollTop;
      var scrollHeight = scrollableElement.scrollHeight;
      var clientHeight = scrollableElement.clientHeight;

      // Se siamo all'inizio o alla fine dello scroll, previeni il bounce
      if (scrollTop <= 0 && e.touches[0].clientY > e.touches[0].clientY) {
        // Scrolling up at top
      } else if (scrollTop + clientHeight >= scrollHeight && e.touches[0].clientY < e.touches[0].clientY) {
        // Scrolling down at bottom
      }
    }
  }

  toggleMobileHeader();
  window.addEventListener('resize', toggleMobileHeader);

  // (2026-07-19) The hamburger belongs to the Aurora glass nav
  // (aurora-desktop-header.js). NEVER rebind it to the legacy drawer —
  // this binding is what made the old menu reappear behind the new one.
  void openMobileMenu; // kept only for closeMobileMenu/window.closeMobileDrawer

  if(closeBtn && mobileDrawer) {
    closeBtn.onclick = function() {
      closeMobileMenu();
    };
  }

  // Aggiungi event listener per cart icon
  const cartIcon = document.getElementById('cart-icon-bubble-wrapper');
  if(cartIcon) {
    cartIcon.addEventListener('click', function(e) {
      e.preventDefault();
      rerenderCartDrawer();
    });
  }

  function rerenderCartDrawer() {
    // Native theme cart drawer (Recharge removed 2026-08-24): fetch fresh
    // contents, render, open — renderContents() opens the drawer itself.
    const nativeDrawer = document.querySelector('cart-drawer');
    if (nativeDrawer && typeof nativeDrawer.open === 'function') {
      const ru = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(ru + '?sections=cart-drawer,cart-icon-bubble')
        .then(function(r){ return r.json(); })
        .then(function(sections){ nativeDrawer.renderContents({ sections: sections }); })
        .catch(function(){ nativeDrawer.open(); });
      return true;
    }
    const rechargeTrigger = document.querySelector('[data-recharge-cart-trigger-observer]');
    if (rechargeTrigger) {
      rechargeTrigger.click();
      return true;
    }
    const trigger =
      document.querySelector('[data-cart-drawer-trigger]') ||
      document.querySelector('[aria-controls*="cart"]') ||
      document.querySelector('a[href="/cart"], a[href$="/cart"]') ||
      document.querySelector('header .header__icon--cart, header .header__icon-cart, .cart-link');
    if (!trigger) {
      console.warn('No cart trigger found');
      return false;
    }
    console.log(trigger);
    trigger.click();
    return true;
  }


  if(cartBtn) {
    cartBtn.onclick = function(e) {
      e.preventDefault();
      rerenderCartDrawer();
    };
  }

  // Chiudi il menu se si clicca fuori dal contenuto
  if (mobileDrawer) {
    mobileDrawer.addEventListener('click', function(e) {
      if(e.target === mobileDrawer) {
        closeMobileMenu();
      }
    });
  }

  // Chiudi il menu con il tasto Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && mobileDrawer && mobileDrawer.classList.contains('active')) {
      closeMobileMenu();
    }
  });

  // === SWIPE GESTURES ===
  var touchStartX = 0;
  var touchStartY = 0;
  var touchEndX = 0;
  var touchEndY = 0;
  var isSwiping = false;
  var swipeThreshold = 120; // Pixel minimi per considerare uno swipe (aumentato)
  var swipeMinDistance = 50; // Distanza minima per iniziare a considerare uno swipe
  var isCarouselSwipe = false; // Flag per evitare conflitti con Flickity
  var swipeStartTime = 0; // Tempo di inizio swipe

  function handleSwipeStart(e) {
    // Controlla se il touch è partito su un carosello Flickity ATTIVO
    var target = e.target;

    // Verifica se siamo nel menu principale (nessun sottomenu visibile)
    var activeSubmenu = document.querySelector('.yomi-mobile-menu-sub.sub-visible');

    // Se siamo nel menu principale, permetti sempre lo swipe
    if (!activeSubmenu) {
      isCarouselSwipe = false;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchEndX = touchStartX;
      touchEndY = touchStartY;
      swipeStartTime = Date.now();
      isSwiping = true;
      return;
    }

    // Siamo in un sottomenu - controlla se il touch è su un carosello Flickity attivo
    var flickityElement = target.closest('.flickity-enabled, .flickity-viewport, .flickity-slider');

    if (flickityElement) {
      // È un carosello attivo, non gestire lo swipe
      isCarouselSwipe = true;
      return;
    }

    // Permetti swipe ovunque nel sottomenu eccetto caroselli attivi
    isCarouselSwipe = false;
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    touchEndX = touchStartX;
    touchEndY = touchStartY;
    swipeStartTime = Date.now();
    isSwiping = true;
  }

  function handleSwipeMove(e) {
    if (!isSwiping || isCarouselSwipe) return;
    touchEndX = e.touches[0].clientX;
    touchEndY = e.touches[0].clientY;

    var diffX = touchEndX - touchStartX;
    var diffY = Math.abs(touchEndY - touchStartY);

    // Solo swipe orizzontale e solo se supera la distanza minima
    if (Math.abs(diffX) > diffY && Math.abs(diffX) > swipeMinDistance) {
      var activeSubmenu = document.querySelector('.yomi-mobile-menu-sub.sub-visible');

      // Feedback visivo per swipe → (tornare indietro nel sottomenu)
      if (activeSubmenu && diffX > swipeMinDistance) {
        activeSubmenu.classList.add('swiping');
        activeSubmenu.style.transform = 'translateX(' + Math.min(diffX - swipeMinDistance, 150) + 'px)';
      }
      // Feedback visivo per swipe ← (chiudere il drawer dal menu principale)
      else if (!activeSubmenu && diffX < -swipeMinDistance) {
        mobileDrawer.classList.add('swiping');
        mobileDrawer.style.transform = 'translateX(' + Math.max(diffX + swipeMinDistance, -150) + 'px)';
      }
    }
  }

  function handleSwipeEnd(e) {
    if (!isSwiping || isCarouselSwipe) {
      isSwiping = false;
      isCarouselSwipe = false;
      return;
    }
    isSwiping = false;

    var diffX = touchEndX - touchStartX;
    var diffY = Math.abs(touchEndY - touchStartY);
    var swipeDuration = Date.now() - swipeStartTime;

    // Rimuovi feedback visivo
    mobileDrawer.classList.remove('swiping');
    mobileDrawer.style.transform = '';
    document.querySelectorAll('.yomi-mobile-menu-sub').forEach(function(sub) {
      sub.classList.remove('swiping');
      sub.style.transform = '';
    });

    // Ignora swipe troppo veloci (probabilmente tap) o troppo lenti
    if (swipeDuration < 100 || swipeDuration > 1000) {
      touchStartX = 0;
      touchStartY = 0;
      touchEndX = 0;
      touchEndY = 0;
      return;
    }

    var activeSubmenu = document.querySelector('.yomi-mobile-menu-sub.sub-visible');

    // Swipe da sinistra a destra (→) = torna indietro nel sottomenu
    // Richiede: distanza > threshold, movimento principalmente orizzontale, sottomenu attivo
    if (diffX > swipeThreshold && Math.abs(diffX) > diffY * 2.5 && activeSubmenu) {
      // Usa la funzione globale per tornare indietro
      if (typeof window.goBackToMainMenu === 'function') {
        window.goBackToMainMenu();
      }
    }

    // Swipe da destra a sinistra (←) = chiudi il drawer (solo dal menu principale)
    // Richiede: distanza > threshold, movimento principalmente orizzontale, nessun sottomenu
    if (diffX < -swipeThreshold && Math.abs(diffX) > diffY * 2.5 && !activeSubmenu) {
      closeMobileMenu();
    }

    // Reset
    touchStartX = 0;
    touchStartY = 0;
    touchEndX = 0;
    touchEndY = 0;
  }

  // Aggiungi event listeners per swipe
  if (mobileDrawer) {
    mobileDrawer.addEventListener('touchstart', handleSwipeStart, { passive: true });
    mobileDrawer.addEventListener('touchmove', handleSwipeMove, { passive: true });
    mobileDrawer.addEventListener('touchend', handleSwipeEnd, { passive: true });
  }
});

// === MOBILE MENU NAVIGATION ===
document.addEventListener('DOMContentLoaded', function() {
  var mainMenu = document.getElementById('yomi-mobile-menu-main');
  var menuLinks = document.querySelectorAll('.yomi-mobile-menu-link');

  function initMobileCarousels() {
    var carousels = document.querySelectorAll('.yomi-mobile-carousel .flickity-carousel');

    if (!window.Flickity) {
      setTimeout(initMobileCarousels, 200);
      return;
    }

    carousels.forEach(function(carousel) {
      if (carousel.classList.contains('flickity-enabled')) return;

      var parent = carousel.closest('.yomi-mobile-menu-sub');
      // Solo inizializza se il sottomenu è visibile
      if (!parent || !parent.classList.contains('sub-visible')) return;

      var slides = carousel.querySelectorAll('.yomi-mobile-promo-block');
      if (slides.length === 0) return;

      new Flickity(carousel, {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        freeScroll: false,
        wrapAround: false,
        accessibility: true,
        setGallerySize: true,
        resize: true,
        imagesLoaded: true,
        selectedAttraction: 0.15,
        friction: 0.8,
        groupCells: 1
      });
    });
  }

  var backBtn = document.getElementById('yomi-mobile-back-btn');
  var currentSubmenuIndex = null;

  // Funzione per mostrare/nascondere il pulsante indietro
  function updateBackButton(show) {
    if (backBtn) {
      if (show) {
        backBtn.style.opacity = '1';
        backBtn.style.visibility = 'visible';
      } else {
        backBtn.style.opacity = '0';
        backBtn.style.visibility = 'hidden';
      }
    }
  }

  // Funzione per tornare al menu principale (globale per swipe)
  window.goBackToMainMenu = function() {
    if (currentSubmenuIndex === null) return;

    var submenu = document.getElementById('yomi-mobile-menu-sub-' + currentSubmenuIndex);
    if (!submenu) return;

    // Animazione: nascondi il sottomenu con slide out
    submenu.classList.add('sub-closing');
    submenu.classList.remove('sub-visible');

    // Mostra il menu principale con animazione
    mainMenu.classList.remove('main-hidden');

    // Nascondi il pulsante indietro
    updateBackButton(false);
    currentSubmenuIndex = null;
    document.querySelectorAll('.yomi-mobile-menu-link[aria-expanded]').forEach(function(l) {
      l.setAttribute('aria-expanded', 'false');
    });

    // Dopo l'animazione, rimuovi la classe closing
    setTimeout(function() {
      submenu.classList.remove('sub-closing');
    }, 350);

    // Resetta lo scroll del menu principale
    var menuContent = document.getElementById('yomi-mobile-menu-content');
    if (menuContent) {
      menuContent.scrollTop = 0;
    }
  };

  // Event listener per il pulsante indietro nell'header
  if (backBtn) {
    backBtn.addEventListener('click', window.goBackToMainMenu);
  }

  menuLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      var idx = link.getAttribute('data-menu-index');
      var submenu = document.getElementById('yomi-mobile-menu-sub-' + idx);
      if (!submenu) return;
      link.setAttribute('aria-expanded', 'true');

      // Salva l'indice del sottomenu corrente
      currentSubmenuIndex = idx;

      // Animazione: nascondi il menu principale con slide
      mainMenu.classList.add('main-hidden');

      // Mostra il sottomenu con animazione
      submenu.classList.add('sub-visible');

      // Mostra il pulsante indietro
      updateBackButton(true);

      // Resetta lo scroll del sottomenu all'inizio
      submenu.scrollTop = 0;

      // Resetta anche lo scroll del contenitore principale
      var menuContent = document.getElementById('yomi-mobile-menu-content');
      if (menuContent) {
        menuContent.scrollTop = 0;
      }

      // Inizializza i caroselli dopo che l'animazione è completa (350ms)
      setTimeout(function() {
        initMobileCarousels();
        // Forza resize dei caroselli già inizializzati
        var carousels = submenu.querySelectorAll('.flickity-enabled');
        carousels.forEach(function(carousel) {
          var flkty = Flickity.data(carousel);
          if (flkty) flkty.resize();
        });
      }, 380);
    });
  });
});

// === TRANSCY POPUP TRIGGER ===
function openTranscyPopup(event) {
  if (event) event.preventDefault();

  // Debug: logga tutti gli elementi Transcy disponibili
  console.log('=== TRANSCY DEBUG ===');
  console.log('_transcy:', window._transcy);
  console.log('_transcy.methods:', window._transcy ? window._transcy.methods : 'N/A');

  var allTranscyElements = document.querySelectorAll('[class*="transcy"], [id*="transcy"]');
  console.log('Elementi Transcy trovati:', allTranscyElements.length);
  allTranscyElements.forEach(function(el, i) {
    console.log(i + ':', el.className || el.id, el);
  });

  // Metodo 1: Usa l'API nativa di Transcy (funziona sia mobile che desktop)
  if (window._transcy && window._transcy.methods) {
    var methods = window._transcy.methods;

    // Prova onShowOrHideSwitcher con il pulsante
    var transcyBtn = document.getElementById('transcyBtnSwitcher');
    if (transcyBtn && typeof methods.onShowOrHideSwitcher === 'function') {
      console.log('Uso onShowOrHideSwitcher');
      // Mostra temporaneamente il pulsante per triggerare
      var originalDisplay = transcyBtn.style.display;
      transcyBtn.style.display = 'block';
      methods.onShowOrHideSwitcher(transcyBtn);
      transcyBtn.style.display = originalDisplay;
      return true;
    }

    // Lista tutti i metodi disponibili
    console.log('Metodi Transcy disponibili:', Object.keys(methods));
  }

  // Metodo 2: Click diretto sul pulsante Transcy (rendendolo temporaneamente visibile)
  var transcyBtn = document.getElementById('transcyBtnSwitcher');
  if (transcyBtn) {
    console.log('Click su transcyBtnSwitcher');
    var originalStyle = transcyBtn.getAttribute('style') || '';
    transcyBtn.style.cssText = 'display: block !important; visibility: visible !important; opacity: 1 !important; position: fixed !important; top: -9999px !important;';
    transcyBtn.click();
    // Ripristina dopo un tick
    setTimeout(function() {
      transcyBtn.setAttribute('style', originalStyle);
    }, 100);
    return true;
  }

  // Metodo 3: Cerca il contenitore switcher e clicca
  var switcherContainer = document.querySelector('#transcySwitcherContainer, .transcy-switcher-container, [id*="transcySwitcher"]');
  if (switcherContainer) {
    console.log('Click su switcherContainer');
    var btn = switcherContainer.querySelector('button, a, [onclick]');
    if (btn) {
      btn.click();
      return true;
    }
    switcherContainer.click();
    return true;
  }

  // Metodo 4: Cerca qualsiasi elemento cliccabile Transcy
  var clickableTranscy = document.querySelector('.transcy-switcher-item-primary, .transcy-switcher-btn, [class*="transcy"][onclick]');
  if (clickableTranscy) {
    console.log('Click su clickableTranscy:', clickableTranscy);
    clickableTranscy.click();
    return true;
  }

  console.log('Nessun elemento Transcy trovato');
  return false;
}


// === Transcy currency change event ===
document.addEventListener('DOMContentLoaded', function() {
  const BTN_ID = 'transcy-btn-apply-switcher';

  function getSelectedCurrency() {
    const selected = document.querySelector(
      '#transcy-select-item-list-currency .transcy-switcher-content__item-selected'
    );
    if (!selected) return null;

    return (
      selected.getAttribute('data-code') ||
      null
    );
  }

  document.addEventListener('click', function (e) {
    const btn = e.target?.closest?.('#' + BTN_ID);
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    const currencyCurrent = getSelectedCurrency();

    // Update the cart currency
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        currency: currencyCurrent
      }),
      keepalive: true,
      credentials: 'same-origin'
    })
    .then(response => {
      if (!response.ok) {
        // try to extract body for better logs
        return response.text().then(text => {
          const err = new Error(`Cart update failed (${response.status} ${response.statusText})`);
          err.status = response.status;
          err.responseText = text;
          throw err;
        });
      }
      return response.json();
    })
    .then(data => {
      window._transcy.methods.onApplyTempData(event);
    })
    .catch(err => {
      console.error('[Transcy currency switch] /cart/update.js error:', err);
      // optional: still proceed with Transcy apply even if cart update fails
      window._transcy?.methods?.onApplyTempData?.(event);
    });

    // Let Transcy proceed with its reload/currency change
  }, true); // capture phase helps if Transcy stops bubbling

});




// === WISHLIST PLUS (SWYM) WIDGET TRIGGER ===
function openWishlistWidget() {
  // Metodo 1: Click sul bottone nativo di Swym
  var swymAnchor = document.querySelector('#notepad-anchor-title, #swym-anchor a, .swym-notepad-button, [data-swym-page]');
  if (swymAnchor) {
    swymAnchor.click();
    return true;
  }

  // Metodo 2: Usa l'API Swym se disponibile
  if (window._swat) {
    // Apri il wishlist widget
    if (typeof window._swat.openWishlistPage === 'function') {
      window._swat.openWishlistPage();
      return true;
    }
    if (typeof window._swat.showWishlistWidget === 'function') {
      window._swat.showWishlistWidget();
      return true;
    }
    if (typeof window._swat.toggleWishlist === 'function') {
      window._swat.toggleWishlist();
      return true;
    }
  }

  // Metodo 3: Prova SwymCallbacks
  if (window.SwymCallbacks) {
    window.SwymCallbacks.forEach(function(cb) {
      if (typeof cb === 'function') cb();
    });
  }

  // Metodo 4: Trigger evento custom Swym
  document.dispatchEvent(new CustomEvent('swym:open-wishlist'));

  // Metodo 5: Fallback - cerca qualsiasi elemento Swym cliccabile
  var swymBtn = document.querySelector('[class*="swym"][class*="anchor"], .swym-heart a, #swym-plugin a');
  if (swymBtn) {
    swymBtn.click();
    return true;
  }

  // Fallback finale: vai alla pagina wishlist
  window.location.href = '/pages/wishlist';
  return false;
}

// Update Transcy label
document.addEventListener('DOMContentLoaded', function() {
  function updateTranscyLabel() {
    var label = document.getElementById('yomi-transcy-label-mobile');
    if (!label) return;

    var lang = '';
    var curr = '';

    // Metodo 1: Leggi direttamente dal DOM di Transcy
    var langElement = document.querySelector('#transcyBtnSwitcher .transcy-language-locale-name, #transcyBtnSwitcher .transcy-switcher-language .transcy-locale-name, .transcy-switcher-language .transcy-english-name');
    var currElement = document.querySelector('#transcyBtnSwitcher .transcy-currency-locale-name, #transcyBtnSwitcher .transcy-switcher-currency .transcy-locale-name');

    if (langElement) {
      lang = langElement.textContent.trim();
    }
    if (currElement) {
      curr = currElement.textContent.trim();
    }

    // Metodo 2: Usa l'API Transcy se disponibile
    if (!lang || !curr) {
      if (window._transcy && window._transcy.state) {
        if (!lang && window._transcy.state.language) {
          lang = window._transcy.state.language.name || window._transcy.state.language.code || '';
        }
        if (!curr && window._transcy.state.currency) {
          curr = window._transcy.state.currency.code || window._transcy.state.currency.name || '';
        }
      }
    }

    // Metodo 3: Usa window.Transcy
    if (!lang || !curr) {
      if (window.Transcy) {
        if (!lang) lang = window.Transcy.language || window.Transcy.currentLanguage || '';
        if (!curr) curr = window.Transcy.currency || window.Transcy.currentCurrency || '';
      }
    }

    // Metodo 4: Leggi da localStorage
    if (!lang || !curr) {
      try {
        if (!lang) {
          var storedLang = localStorage.getItem('transcy_language') || localStorage.getItem('transcy_current_language');
          if (storedLang) lang = storedLang.toUpperCase();
        }
        if (!curr) {
          var storedCurr = localStorage.getItem('transcy_currency') || localStorage.getItem('transcy_current_currency');
          if (storedCurr) curr = storedCurr.toUpperCase();
        }
      } catch(e) {}
    }

    // Fallback defaults
    if (!lang) lang = 'EN';
    if (!curr) curr = 'USD';

    // Formatta il label (abbrevia lingua se troppo lunga)
    var langShort = lang.length > 3 ? lang.substring(0, 2).toUpperCase() : lang.toUpperCase();
    // Transcy's currency text often already contains a symbol in
    // parentheses ("USD ($)"), which used to render as "EN (USD ($))".
    // Extract just the symbol so the label matches desktop: "EN ($)".
    var currTrim = curr.trim();
    var symMatch = currTrim.match(/\(([^)]+)\)/);
    var symbol = symMatch ? symMatch[1] : currTrim.toUpperCase();
    var currencySymbols = { USD: '$', EUR: '€', GBP: '£', CAD: '$', AUD: '$', JPY: '¥', CNY: '¥', TWD: 'NT$' };
    if (currencySymbols[symbol]) symbol = currencySymbols[symbol];

    label.textContent = langShort + ' (' + symbol + ')';
  }

  // Attendi che Transcy sia caricato
  function initTranscyLabel() {
    updateTranscyLabel();

    // Osserva cambiamenti nel DOM di Transcy (the previous version had a
    // truncated assignment here that threw at runtime and killed the observer)
    var transcyContainer = document.querySelector('#transcySwitcherContainer, .transcy-switcher-container');
    if (transcyContainer) {
      var observer = new MutationObserver(updateTranscyLabel);
      observer.observe(transcyContainer, { childList: true, subtree: true, characterData: true });
    }
  }

  // Inizializza con ritardo per aspettare Transcy
  setTimeout(initTranscyLabel, 1000);
  setTimeout(updateTranscyLabel, 2000);
  setTimeout(updateTranscyLabel, 3000);

  // Eventi Transcy
  document.addEventListener('transcy:updated', updateTranscyLabel);
  document.addEventListener('transcy:changed', updateTranscyLabel);
  window.addEventListener('transcy:language:changed', updateTranscyLabel);
  window.addEventListener('transcy:currency:changed', updateTranscyLabel);

  // Aggiorna periodicamente
  setInterval(updateTranscyLabel, 3000);
});

// === CART DRAWER ===
// Apre automaticamente tramite event listeners sopra


// Aggiorna il badge carrello solo su eventi chiave
function updateCartCount() {
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cart => {
      const countSpan = document.getElementById('CartCount');
      try {
        if (countSpan) {
          const count = String(cart.item_count);
          document.querySelectorAll('.yomi-cart-count').forEach(function(el) {
            el.classList.toggle('has-items', cart.item_count > 0);
          });
          const hasSVG = !!countSpan.querySelector('svg');
          if (hasSVG) {
            let valueEl = countSpan.querySelector('.count-value');
            if (!valueEl) {
              valueEl = document.createElement('span');
              valueEl.className = 'count-value';
              valueEl.style.marginLeft = '6px';
              countSpan.appendChild(valueEl);
            }
            valueEl.textContent = count;
          } else {
            countSpan.textContent = count;
          }
        }
      } catch (e) {
        // ignore errors updating cart count
      }
    });
}

document.addEventListener('DOMContentLoaded', () => {
  updateCartCount(); // aggiorna al caricamento
  // aggiorna quando si apre il carrello (puoi aggiungere altri eventi se necessario)
  const cartIcon = document.getElementById('cart-icon-bubble');
  if (cartIcon) {
    cartIcon.addEventListener('click', updateCartCount);
  }
});

// === DESKTOP SEARCH ===
(function() {
  'use strict';
  const searchTrigger = document.querySelector('.yomi-search-trigger');
  const searchDropdown = document.getElementById('yomi-search-dropdown');
  const searchOverlay = document.getElementById('yomi-search-overlay');
  const searchInput = document.getElementById('yomi-search-input');
  const searchResults = document.getElementById('yomi-search-results');
  const searchClear = document.getElementById('yomi-search-clear');

  if (!searchDropdown) return;

  let searchTimeout;
  let currentQuery = '';

  function toggleSearch(show) {
    const isOpen = show !== undefined ? show : !searchDropdown.classList.contains('active');
    searchDropdown.classList.toggle('active', isOpen);
    searchOverlay.classList.toggle('active', isOpen);

    if (isOpen) {
      setTimeout(() => searchInput.focus(), 100);
    } else {
      searchInput.value = '';
      searchClear.classList.remove('active');
      searchResults.innerHTML = '<div class="yomi-search-empty">' + yhI18n('i18nStart', 'Start typing to search...') + '</div>';
      currentQuery = '';
    }
  }

  async function performSearch(query) {
    if (!query || query.length < 2) {
      searchResults.innerHTML = '<div class="yomi-search-empty">' + yhI18n('i18nStart', 'Start typing to search...') + '</div>';
      return;
    }

    searchResults.innerHTML = '<div class="yomi-search-loading">' + yhI18n('i18nSearching', 'Searching...') + '</div>';

    try {
      const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`);
      const data = await response.json();

      if (query !== currentQuery) return;

      const products = data.resources.results.products || [];
      if (products.length === 0) {
        searchResults.innerHTML = '<div class="yomi-search-empty">' + yhI18n('i18nNores', 'No products found') + '</div>';
        return;
      }

      let html = '';
      products.forEach(product => {
        const price = product.price ? (product.price / 100).toFixed(2) : '0.00';
        const imgUrl = product.featured_image ? product.featured_image.url : '';

        html += `
          <a href="${product.url}" class="yomi-search-item" role="option">
            ${imgUrl ? `<img src="${imgUrl}" alt="${product.title}" class="yomi-search-img" loading="lazy">` : ''}
            <div class="yomi-search-info">
              <div class="yomi-search-title">${product.title}</div>
              <div class="yomi-search-price">€${price}</div>
              ${product.vendor ? `<div class="yomi-search-vendor">${product.vendor}</div>` : ''}
            </div>
          </a>
        `;
      });
      html += `<a href="/search?q=${encodeURIComponent(query)}" class="yomi-search-view-all">${yhI18n('i18nViewall', 'View all results')}</a>`;
      searchResults.innerHTML = html;
    } catch (error) {
      searchResults.innerHTML = '<div class="yomi-search-empty">Search error. Please try again.</div>';
    }
  }

  if(searchTrigger) searchTrigger.addEventListener('click', () => toggleSearch());
  searchOverlay.addEventListener('click', () => toggleSearch(false));
  searchInput.addEventListener('input', (e) => {
    const query = e.target.value.trim();
    currentQuery = query;
    searchClear.classList.toggle('active', query.length > 0);
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => performSearch(query), 300);
  });
  searchClear.addEventListener('click', () => {
    searchInput.value = '';
    searchClear.classList.remove('active');
    searchInput.focus();
    currentQuery = '';
    searchResults.innerHTML = '<div class="yomi-search-empty">' + yhI18n('i18nStart', 'Start typing to search...') + '</div>';
  });
  searchInput.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') toggleSearch(false);
  });
  document.addEventListener('click', (e) => {
    if (!searchDropdown.contains(e.target) && !searchTrigger?.contains(e.target) && searchDropdown.classList.contains('active')) {
      toggleSearch(false);
    }
  });
})();

// === DESKTOP MEGA MENU CAROUSELS ===
document.addEventListener('DOMContentLoaded', function() {
  // Funzione per inizializzare un singolo carosello desktop
  function initDesktopCarousel(carousel) {
    if (!carousel || carousel.classList.contains('flickity-enabled') || !window.Flickity) return;

    // Conta le slide
    var slides = carousel.querySelectorAll('.yomi-promo-block');
    if (slides.length === 0) return;

    var flkty = new Flickity(carousel, {
      cellAlign: 'left',
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      draggable: slides.length > 2, // Solo draggable se ci sono abbastanza slide
      freeScroll: false,
      wrapAround: false,
      accessibility: false,
      setGallerySize: true,
      resize: true,
      imagesLoaded: true,
      selectedAttraction: 0.2,
      friction: 0.6,
      groupCells: 1,
      percentPosition: false // Usa pixel invece di percentuali per posizionamento preciso
    });

    return flkty;
  }
  // Fix scroll
  const originalScrollTo = window.scrollTo;
  const startedAt = Date.now();

  window.scrollTo = function (x, y) {
    const left = typeof x === 'object' ? (x.left ?? x.x ?? 0) : x;
    const top = typeof x === 'object' ? (x.top ?? x.y ?? 0) : y;

    const isTopScroll = left === 0 && top === 0;
    const isEarly = Date.now() - startedAt < 4000;
    const userScrolled = window.scrollY > 120;

    if (isTopScroll && isEarly && userScrolled) {
      console.log('Blocked early unwanted scrollTo(0,0)');
      return;
    }

    return originalScrollTo.apply(this, arguments);
  };

  /* ============================================================
     DESKTOP MEGA MENU — hover intent + keyboard controller
     - Pointer: open after a configurable delay (accidental-open
       protection); close after a forgiving close-intent delay.
     - Click / keyboard: immediate (no delay on activation).
     - Escape closes and returns focus to the trigger.
     - Only one menu open at a time; aria-expanded kept accurate.
     - Without JS the CSS :hover/:focus-within fallback applies
       (html.no-js rules), so links always work.
     ============================================================ */
  (function initYomiMegaMenu() {
    var yomiMegaRoot = document.querySelector('.yomi-header-wrapper');
    var OPEN_DELAY = yomiMegaRoot ? parseInt(yomiMegaRoot.getAttribute('data-mega-open-delay'), 10) : NaN;
    if (isNaN(OPEN_DELAY)) OPEN_DELAY = 200;
    var CLOSE_DELAY = yomiMegaRoot ? parseInt(yomiMegaRoot.getAttribute('data-mega-close-delay'), 10) : NaN;
    if (isNaN(CLOSE_DELAY)) CLOSE_DELAY = 300;
    var items = Array.prototype.slice.call(document.querySelectorAll('.yomi-nav-item[data-yomi-mega-item]'));
    if (!items.length) return;

    var openTimer = null;
    var closeTimer = null;

    function trigger(item) { return item.querySelector('.yomi-nav-link'); }

    function closeItem(item) {
      item.classList.remove('is-open');
      var t = trigger(item);
      if (t) t.setAttribute('aria-expanded', 'false');
    }

    function closeAll(except) {
      items.forEach(function(item) {
        if (item !== except) closeItem(item);
      });
    }

    function openItem(item) {
      closeAll(item);
      item.classList.add('is-open');
      var t = trigger(item);
      if (t) t.setAttribute('aria-expanded', 'true');
    }

    items.forEach(function(item) {
      var t = trigger(item);

      // Pointer: delayed open, forgiving close
      item.addEventListener('mouseenter', function() {
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(function() { openItem(item); }, OPEN_DELAY);
      });
      item.addEventListener('mouseleave', function() {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function() { closeItem(item); }, CLOSE_DELAY);
      });

      // Keyboard: focus keeps the menu reachable; ArrowDown/Space open immediately
      if (t) {
        t.addEventListener('keydown', function(e) {
          if (e.key === 'ArrowDown' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            openItem(item);
            var firstLink = item.querySelector('.yomi-mega-menu a');
            if (firstLink) firstLink.focus();
          }
        });
      }

      // Keep open while focus is inside the panel; close when it leaves
      item.addEventListener('focusin', function() {
        clearTimeout(closeTimer);
        openItem(item);
      });
      item.addEventListener('focusout', function(e) {
        if (!item.contains(e.relatedTarget)) closeItem(item);
      });
    });

    // Escape closes the open menu and returns focus to its trigger
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      var open = items.filter(function(item) { return item.classList.contains('is-open'); })[0];
      if (open) {
        closeItem(open);
        var t = trigger(open);
        if (t) t.focus();
      }
    });

    // Click/tap outside closes everything
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.yomi-nav-item[data-yomi-mega-item]')) closeAll();
    });
  })();
});